// --- PAGINATION COMPONENT ---
const Pagination = ({ postsPerPage, totalPosts, paginate, currentPage }) => {
  const pageNumbers = [];

  for (let i = 1; i <= Math.ceil(totalPosts / postsPerPage); i++) {
    pageNumbers.push(i);
  }

  if (pageNumbers.length <= 1) return null; // Don't render if only one page

  return (
    <nav className="mt-10">
      <ul className="flex justify-center items-center space-x-2">
        {pageNumbers.map(number => (
          <li key={number}>
            <button
              onClick={() => paginate(number)}
              className={`px-4 py-2 rounded-md transition-all duration-200 text-sm font-semibold ${
                currentPage === number
                  ? 'bg-blue-600 text-white shadow-lg scale-110'
                  : 'bg-white text-blue-600 hover:bg-blue-100 hover:shadow-md'
              }`}
            >
              {number}
            </button>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default Pagination;